export const SERVER_ERROR = 'SERVER_ERROR'



// WEBPACK FOOTER //
// ./web/static/js/actions/shared.js